import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { AppConfig, ISelfServMeta } from "@aa/common";

import { SelfServMetaCache } from "@aa/selfserv/shared";

@Component({
  selector: "aa-about-page",
  templateUrl: "./about.component.html",
  host: { class: "anonymous-page" },
  styleUrls: ["./about.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AboutComponent {
  public readonly version: string;
  public readonly commit: string | null;
  public readonly serverCommit: string | null;
  public readonly meta: ISelfServMeta | null;

  constructor() {
    const appConfig = inject(AppConfig);
    const metaCache = inject(SelfServMetaCache);

    this.version = "v" + appConfig.version;
    this.commit = appConfig.commit;
    this.serverCommit = appConfig.serverCommit;
    this.meta = metaCache.meta;
  }
}
